module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a09-cca59cde2cb989de2943ddb1e18ce0e7.jpg";